import { useOutletContext } from 'react-router-dom';
import { CategoryData } from '../overview/OverviewDistrictCard';
import Schools from '../../interfaces/SchoolsInterface';
import { WorkflowTransitionResponse, WorkflowStatus } from '../../services/workflowService';

interface OutletContextValues {
  uploadProgress: {
    [key: string]: CategoryData[];
  };
  schools: Schools[];
  dataQcSchool: string;
  shouldShowActionButtons?: boolean;
  updateWorkflowStatusFromTransition?: (transitionResponse: WorkflowTransitionResponse) => void;
  workflowStatus?: WorkflowStatus | null;
}

export function useDataQcOutletContext() {
  return useOutletContext<OutletContextValues>();
}

export type { OutletContextValues };
